import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MessageNameAvatarComponent } from '../message-name-avatar/message-name-avatar.component';

@Component({
  selector: 'app-message-preview',
  imports: [MatRipple, NgClass, MessageNameAvatarComponent],
  templateUrl: './message-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePreviewComponent {
  public isActive = input(false);
}
